import React from 'react';
import { Box, Container, Typography, Paper, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { ExpandMore, HelpOutline, Payments, Devices, SupportAgent } from '@mui/icons-material';
import PublicLayout from "../../layouts/PublicLayout";

const faqData = [
  {
    category: "General & Setup",
    icon: <Devices sx={{ color: '#f6521a' }} />,
    questions: [
      { q: "What is TPOS?", a: "TPOS (Truemenu Point of Sale) is an all-in-one cloud-based software designed to manage billing, KOT, inventory, and online orders for restaurants." },
      { q: "Does TPOS work offline?", a: "Yes! TPOS features a robust offline mode that allows you to continue billing even during internet outages. Data syncs automatically once back online." }
    ]
  },
  {
    category: "Payments & Hardware",
    icon: <Payments sx={{ color: '#f6521a' }} />,
    questions: [
      { q: "Which hardware is compatible?", a: "TPOS is compatible with standard Windows/Android devices, ESC/POS thermal printers, and integrated payment terminals." },
      { q: "How are digital payments settled?", a: "Digital payments are settled directly to your bank account on a T+2 or T+3 basis as per RBI regulations." }
    ]
  },
  {
    category: "Support & Security",
    icon: <SupportAgent sx={{ color: '#f6521a' }} />,
    questions: [
      { q: "How secure is my business data?", a: "We use 256-bit encryption and all data is localized in Indian servers as per DPDP Act 2023 mandates." },
      { q: "What kind of support do you provide?", a: "We provide 24/7 technical support via WhatsApp, Email, and Phone for all our registered merchants." }
    ]
  }
];

export default function Faqs() {
  return (
    <PublicLayout>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <HelpOutline sx={{ fontSize: 50, color: '#f6521a', mb: 2 }} />
          <Typography variant="h3" fontWeight={800} gutterBottom>
            Frequently Asked <span style={{ color: "#f6521a" }}>Questions</span>
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Everything you need to know about TPOS and how it grows your business.
          </Typography>
        </Box>

        {faqData.map((group, idx) => (
          <Box key={idx} sx={{ mb: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
              {group.icon}
              <Typography variant="h6" fontWeight={800}>{group.category}</Typography>
            </Box>
            
            {group.questions.map((item, qIdx) => (
              <Accordion 
                key={qIdx} 
                elevation={0} 
                sx={{ 
                  mb: 1, 
                  border: '1px solid #eee', 
                  borderRadius: '12px !important',
                  '&:before': { display: 'none' } 
                }}
              >
                <AccordionSummary expandIcon={<ExpandMore sx={{ color: '#f6521a' }} />}>
                  <Typography fontWeight={700}>{item.q}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ borderTop: '1px solid #f9f9f9', py: 3 }}>
                  <Typography variant="body2" color="text.secondary" lineHeight={1.7}>
                    {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        ))}
      </Container>
    </PublicLayout>
  );
}